/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAvailableForPi2$Json } from '../fn/language/get-available-for-pi-2-json';
import { GetAvailableForPi2$Json$Params } from '../fn/language/get-available-for-pi-2-json';
import { getAvailableForPi2$Plain } from '../fn/language/get-available-for-pi-2-plain';
import { GetAvailableForPi2$Plain$Params } from '../fn/language/get-available-for-pi-2-plain';
import { LanguageCto } from '../models/language-cto';

@Injectable({ providedIn: 'root' })
export class LanguageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAvailableForPi2()` */
  static readonly GetAvailableForPi2Path = '/aphealthcheck/v1/languages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableForPi2$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableForPi2$Plain$Response(params?: GetAvailableForPi2$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageCto>>> {
    return getAvailableForPi2$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailableForPi2$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableForPi2$Plain(params?: GetAvailableForPi2$Plain$Params, context?: HttpContext): Observable<Array<LanguageCto>> {
    return this.getAvailableForPi2$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageCto>>): Array<LanguageCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailableForPi2$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableForPi2$Json$Response(params?: GetAvailableForPi2$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageCto>>> {
    return getAvailableForPi2$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailableForPi2$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailableForPi2$Json(params?: GetAvailableForPi2$Json$Params, context?: HttpContext): Observable<Array<LanguageCto>> {
    return this.getAvailableForPi2$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageCto>>): Array<LanguageCto> => r.body)
    );
  }

}
